import React from 'react';
import { useNavigate } from 'react-router';
import { useRecoilState } from 'recoil';
import { CheckPurple } from '#assets/svg';
import { Button, Text } from '#atoms';
import { PATH } from '#const/path';
import { $confirmationFormState } from '#states/atoms/confirmationFormState';
import { useProgress } from '#templates';
import {
  ArticleContainer,
  ButtonContainer,
  Container,
  ContentContainer,
  FieldContainer
} from './styles';

export function ApplicationSuccess() {
  const navigate = useNavigate();

  return (
    <Container>
      <ContentContainer>
        <ArticleContainer>
          <ContentContainer className="check">
            <CheckPurple />
            <Text textStyle="display">결제가 완료되었습니다!</Text>
          </ContentContainer>
          <FieldContainer>
            <Text textStyle="t3" textColor="white">
              수강 신청서를 작성하고 <br /> 수업 일정을 잡아보세요
            </Text>
          </FieldContainer>
        </ArticleContainer>
      </ContentContainer>
      <ButtonContainer>
        <Button onClick={() => navigate(PATH.APPLICATION)}>
          신청서 작성하기
        </Button>
      </ButtonContainer>
    </Container>
  );
}
